import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVaultComponent } from './simple-icons-vault.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVaultComponent ],
    exports:      [ SimpleIconsVaultComponent ],
    bootstrap:    []
})
export class SimpleIconsVaultModule {}
